export const namesMap = {
  kr: '韩国',
  us: '美国',
  jp: '日本',
  de: '德国',
  fr: '法国',
  gb: '英国',
  ch: '瑞士',
  ru: '俄罗斯'
}